import actions from './actions';

const {
  GET_EMPLOYEES,
  SET_EMPLOYEES,
  GET_EMPLOYEES_LOADING,
  GET_EMPLOYEE,
  SET_EMPLOYEE,
  GET_EMPLOYEE_LOADING,
  CREATE_EMPLOYEE,
  CREATE_EMPLOYEE_LOADING,
  UPDATE_EMPLOYEE,
  UPDATE_EMPLOYEE_LOADING,
  DELETE_EMPLOYEE,
  DELETE_EMPLOYEE_LOADING,
  REACTIVATE_EMPLOYEE,
  REACTIVATE_EMPLOYEE_LOADING,
  SEARCH_EMPLOYEES,
  SET_SEARCH_RESULTS,
  SEARCH_EMPLOYEES_LOADING,
  SET_EMPLOYEE_FILTERS,
  CLEAR_EMPLOYEE_FILTERS,
  GET_SALARY_RANGE,
  SET_SALARY_RANGE,
  GET_ACTIVE_EMPLOYEES,
  SET_ACTIVE_EMPLOYEES,
  GET_EMPLOYEES_BY_BRANCH,
  SET_EMPLOYEES_BY_BRANCH,
  GET_EMPLOYEES_BY_POSITION,
  SET_EMPLOYEES_BY_POSITION,
  CLEAR_EMPLOYEES,
  CLEAR_EMPLOYEE
} = actions;

const initialState = {
  employees: [],
  employee: null,
  searchResults: [],
  activeEmployees: [],
  employeesByBranch: [],
  employeesByPosition: [],
  salaryRange: null,
  filters: {},
  loading: {
    employees: false,
    employee: false,
    create: false,
    update: false,
    delete: false,
    reactivate: false,
    search: false
  },
  pagination: {
    current: 1,
    pageSize: 10,
    total: 0
  }
};

const employeesReducer = (state = initialState, action: any) => {
  const { type, data, loading, filters } = action;

  switch (type) {
    case GET_EMPLOYEES:
      return {
        ...state,
        loading: {
          ...state.loading,
          employees: true
        }
      };

    case SET_EMPLOYEES:
      return {
        ...state,
        employees: data.employees || data,
        pagination: data.pagination || state.pagination,
        loading: {
          ...state.loading,
          employees: false
        }
      };

    case GET_EMPLOYEES_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          employees: loading
        }
      };

    case GET_EMPLOYEE:
      return {
        ...state,
        loading: {
          ...state.loading,
          employee: true
        }
      };

    case SET_EMPLOYEE:
      return {
        ...state,
        employee: data,
        loading: {
          ...state.loading,
          employee: false
        }
      };

    case GET_EMPLOYEE_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          employee: loading
        }
      };

    case CREATE_EMPLOYEE:
      return {
        ...state,
        loading: {
          ...state.loading,
          create: true
        }
      };

    case CREATE_EMPLOYEE_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          create: loading
        }
      };

    case UPDATE_EMPLOYEE:
      return {
        ...state,
        loading: {
          ...state.loading,
          update: true
        }
      };

    case UPDATE_EMPLOYEE_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          update: loading
        }
      };

    case DELETE_EMPLOYEE:
      return {
        ...state,
        loading: {
          ...state.loading,
          delete: true
        }
      };

    case DELETE_EMPLOYEE_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          delete: loading
        }
      };

    case REACTIVATE_EMPLOYEE:
      return {
        ...state,
        loading: {
          ...state.loading,
          reactivate: true
        }
      };

    case REACTIVATE_EMPLOYEE_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          reactivate: loading
        }
      };

    case SEARCH_EMPLOYEES:
      return {
        ...state,
        loading: {
          ...state.loading,
          search: true
        }
      };

    case SET_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: data,
        loading: {
          ...state.loading,
          search: false
        }
      };

    case SEARCH_EMPLOYEES_LOADING:
      return {
        ...state,
        loading: {
          ...state.loading,
          search: loading
        }
      };

    case SET_EMPLOYEE_FILTERS:
      return {
        ...state,
        filters: { ...state.filters, ...filters }
      };

    case CLEAR_EMPLOYEE_FILTERS:
      return {
        ...state,
        filters: {}
      };

    case GET_SALARY_RANGE:
      return {
        ...state
      };

    case SET_SALARY_RANGE:
      return {
        ...state,
        salaryRange: data
      };

    case GET_ACTIVE_EMPLOYEES:
      return {
        ...state
      };

    case SET_ACTIVE_EMPLOYEES:
      return {
        ...state,
        activeEmployees: data
      };

    case GET_EMPLOYEES_BY_BRANCH:
      return {
        ...state
      };

    case SET_EMPLOYEES_BY_BRANCH:
      return {
        ...state,
        employeesByBranch: data
      };

    case GET_EMPLOYEES_BY_POSITION:
      return {
        ...state
      };

    case SET_EMPLOYEES_BY_POSITION:
      return {
        ...state,
        employeesByPosition: data
      };

    case CLEAR_EMPLOYEES:
      return {
        ...state,
        employees: [],
        searchResults: [],
        activeEmployees: [],
        employeesByBranch: [],
        employeesByPosition: []
      };

    case CLEAR_EMPLOYEE:
      return {
        ...state,
        employee: null
      };

    default:
      return state;
  }
};

export { employeesReducer };
